const SelectionSort_java = `import java.util.*;

class SelectionSort {
	void SelectionSort(int arr[]){
		int n = arr.length;
        for (int i = 0; i < n-1; i++){
            int min_idx = i;
            for (int j = i+1; j < n; j++){
                if (arr[j] < arr[min_idx]){
                    min_idx = j;
				}
			}
            int temp = arr[min_idx];
            arr[min_idx] = arr[i];
            arr[i] = temp;
        }
	}

	public static void main(String args[]){
		SelectionSort ob = new SelectionSort();
		int arr[] = { 9, 8, 7, 6, 5, 4, 3, 2, 1 };
		ob.SelectionSort(arr);
		System.out.println("Sorted array");
		for (int i = 0; i < arr.length; ++i){
			System.out.print(arr[i] + " ");
        }
	}
}`;

export default SelectionSort_java;
